import { connect } from 'react-redux';
import LoadingOverlay from './LoadingOverlay';

const mapDataToProps = (state) => ({
  showSpinner: state.loading.asyncActions > 0 && state.modal.isOpen === false,
});

export default connect(mapDataToProps)(LoadingOverlay);
